@if (isMaintenance$ | async) {
  <app-maintenance-mode></app-maintenance-mode>
} @else {
    @if (isSupported) {
      <router-outlet></router-outlet>
    } @else {
      <app-mobile-coming-soon></app-mobile-coming-soon>
    }
}

@if (isLoading$ | async) {
  <app-loading-animation width="270px" height="270px"></app-loading-animation>
}

